import React, { useRef, useEffect } from 'react'
import { IWebinar } from '..'
import moment from 'moment'
import { format } from 'date-fns-tz'
import { CTALink } from 'marketing-site/src/library/elements/CTALink'
import * as Utils from 'marketing-site/src/library/utils'
import useTranslate from 'marketing-site/src/library/hooks/useTranslate'

interface IProps {
  firstName: string
  joinUrl: string
  webinar: IWebinar
}

export function WebinarHeroConfirmation({ firstName, webinar, joinUrl }: IProps) {
  const headerRef = useRef<HTMLHeadingElement>(null)
  const { translate } = useTranslate()
  useEffect(() => {
    if (headerRef.current) {
      headerRef.current.focus()
    }
  }, [])

  const startTime = moment(webinar.zoom?.startTimestamp).utc().format('YYYYMMDDTHHmmss') + 'Z'
  const endTime = moment(webinar.zoom?.endTimestamp).utc().format('YYYYMMDDTHHmmss') + 'Z'
  const googleUrl = `https://calendar.google.com/calendar/r/eventedit?
    text=${
      webinar.title
    }&dates=${startTime}/${endTime}&sf=true&details=Thanks for signing up for this Intercom webinar: ${encodeURIComponent(
    `http://www.intercom.com/webinars/${webinar.slug}`,
  )}\n\nJoin this webinar at: ${encodeURIComponent(
    joinUrl,
  )}\n\nOr if you can't make it, don't worry, we'll follow up with an email and the recording.`

  const icalUrl = `/api/webinars/ical?title=${encodeURIComponent(
    webinar.title,
  )}&startTime=${startTime}&endTime=${endTime}&slug=${webinar.slug}&joinUrl=${encodeURIComponent(
    joinUrl,
  )}`

  return (
    <div className="webinars__form webinars__form--confirmation">
      <h3 ref={headerRef} tabIndex={-1}>
        {translate("You're registered,")} {firstName}
      </h3>

      <p>{translate('A confirmation email is on its way.')}</p>

      <p className="webinar-start">
        {webinar.zoom && format(webinar.zoom.startTimestamp, 'EEE d LLLL h:mm bbbb z')}
      </p>

      <hr />

      <p>{translate('Add it to your calendar')}</p>

      <div className="calendar-links">
        <CTALink
          bgColor={Utils.CTATheme.BlackFill}
          text="Google"
          url={googleUrl}
          newWindow={true}
        />
        <CTALink bgColor={Utils.CTATheme.BlackFill} text="iCal" url={icalUrl} newWindow={true} />
      </div>
    </div>
  )
}
